import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { styled } from "../../../theme";
import { Text } from "../../../text";
import { Checkbox } from "../checkbox";
import { ItemLabel } from "../item-label";
export const CheckboxItem = memo(({ label, disabled, children, ...checkboxProps }) => (_jsxs(_Fragment, { children: [_jsxs(ItemLabel, { tabIndex: disabled ? -1 : 0, disabled: disabled, children: [_jsx(Checkbox, { disabled: disabled, ...checkboxProps }), _jsx(TextLabel, { children: label })] }), children] })));
const TextLabel = styled(Text) `
  font-size: 1.25em;
  line-height: 1.75em;
  margin-top: -0.2em;
  padding-left: 1.5em;
  pointer-events: none;

  a {
    pointer-events: auto;
  }
`;
